import React, { useContext, useState } from "react";
import MenuTool from "../../components/Toolnav/MenuTool";
import Member from "./components/Member";
import { AiOutlinePlus } from "react-icons/ai";
import AddMember from "./components/AddMember";
import { useQuery } from "@tanstack/react-query";
import { handleFetchCompanies } from "../../api/company";
import { AuthContext } from "../../contexts/AuthContext";

export default function AllMembers() {
  const { auth } = useContext(AuthContext);
  const access = ["Admin", "Instructor"];
  const [createModal, setCreateModal] = useState<boolean>(false);

  const { data: companies } = useQuery({
    queryKey: ["companies"],
    queryFn: handleFetchCompanies,
  });

  return (
    <div className="">
      <MenuTool
        menus={[{ id: 1, name: "All Members", to: "/members" }]}
        actions={
          <>
            {access?.includes(auth?.role) && (
              <button
                onClick={() => setCreateModal(true)}
                className="flex justify-center items-center border py-1 px-4 bg-blue-100"
              >
                <AiOutlinePlus /> <span className="mx-1">Add</span>
              </button>
            )}
          </>
        }
      />
      <div className="p-2">
        {companies?.payload?.map((member: any, index: number) => (
          <Member member={member} key={index} />
        ))}
      </div>

      <AddMember isVisible={createModal} setVisible={setCreateModal} />
    </div>
  );
}
